/**
 * @generated SignedSource<<bb3338a7ffcb3434867a021892f4a7b0>>
 * @relayHash 5643b33509d59f3bca49d98daef42410
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e13e8111ed21bae2a0edf7a53f724b3c2c585d4d3210547daf4e49a347e1fa08

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraContainerNavigationQueryInput = {
  projectKeyQuery?: JiraContainerNavigationByProjectKeyQueryInput | null | undefined;
  scopeId?: string | null | undefined;
};
export type JiraContainerNavigationByProjectKeyQueryInput = {
  cloudId: string;
  projectKey: string;
};
export type HorizontalNavJiraInnerQuery$variables = {
  cloudId: string;
  containerNavigationInput: JiraContainerNavigationQueryInput;
  projectAri: string;
  projectKey: string;
  useProjectAri: boolean;
  useProjectKey: boolean;
};
export type HorizontalNavJiraInnerQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"JiraProjectNavigationContent">;
};
export type HorizontalNavJiraInnerQuery = {
  response: HorizontalNavJiraInnerQuery$data;
  variables: HorizontalNavJiraInnerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerNavigationInput"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectAri"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useProjectAri"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useProjectKey"
},
v6 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v7 = [
  {
    "kind": "ScalarField",
    "name": "canPerform"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = [
  {
    "kind": "ScalarField",
    "name": "projectType"
  },
  {
    "kind": "ScalarField",
    "name": "projectId"
  },
  {
    "concreteType": "JiraAvatar",
    "kind": "LinkedField",
    "name": "avatar",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "large"
      }
    ]
  },
  {
    "kind": "ScalarField",
    "name": "name"
  },
  {
    "alias": "projectKey",
    "kind": "ScalarField",
    "name": "key"
  },
  {
    "kind": "ScalarField",
    "name": "projectStyle"
  },
  {
    "alias": "canEditProjectConfig",
    "args": [
      {
        "kind": "Literal",
        "name": "type",
        "value": "EDIT_PROJECT_CONFIG"
      }
    ],
    "concreteType": "JiraProjectAction",
    "kind": "LinkedField",
    "name": "action",
    "plural": false,
    "selections": (v7/*: any*/),
    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
  },
  {
    "alias": "canViewProjectConfig",
    "args": [
      {
        "kind": "Literal",
        "name": "type",
        "value": "VIEW_PROJECT_CONFIG"
      }
    ],
    "concreteType": "JiraProjectAction",
    "kind": "LinkedField",
    "name": "action",
    "plural": false,
    "selections": (v7/*: any*/),
    "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
  },
  (v8/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isFavourite"
  },
  {
    "kind": "ScalarField",
    "name": "webUrl"
  },
  {
    "kind": "ScalarField",
    "name": "status"
  },
  {
    "kind": "ClientExtension",
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__id"
      }
    ]
  },
  {
    "kind": "ScalarField",
    "name": "key"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "HorizontalNavJiraInnerQuery",
    "selections": [
      {
        "args": [
          (v6/*: any*/),
          {
            "kind": "Variable",
            "name": "containerNavigationInput",
            "variableName": "containerNavigationInput"
          },
          {
            "kind": "Variable",
            "name": "projectAri",
            "variableName": "projectAri"
          },
          {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
          },
          {
            "kind": "Variable",
            "name": "useProjectAri",
            "variableName": "useProjectAri"
          },
          {
            "kind": "Variable",
            "name": "useProjectKey",
            "variableName": "useProjectKey"
          }
        ],
        "kind": "FragmentSpread",
        "name": "JiraProjectNavigationContent"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "HorizontalNavJiraInnerQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "useProjectKey",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v6/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "projectKey"
                  }
                ],
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": (v9/*: any*/)
              }
            ]
          },
          {
            "condition": "useProjectAri",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "projectAri"
                  }
                ],
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProject",
                "plural": false,
                "selections": (v9/*: any*/)
              }
            ]
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "containerNavigationInput"
              }
            ],
            "kind": "LinkedField",
            "name": "containerNavigation",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canEdit"
                  }
                ],
                "type": "JiraContainerNavigation"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v8/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          },
          {
            "args": [
              (v6/*: any*/)
            ],
            "concreteType": "JiraWorkManagementLicensing",
            "kind": "LinkedField",
            "name": "jwmLicensing",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "currentUserSeatEdition"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e13e8111ed21bae2a0edf7a53f724b3c2c585d4d3210547daf4e49a347e1fa08",
    "metadata": {},
    "name": "HorizontalNavJiraInnerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1a3afbf86be1c4ab2f5f6bc237098d0e";

export default node;
